/* global Word console */

export async function insertText(text: string) {
  // Write text to the document.
  try {
    await Word.run(async (context) => {
      let body = context.document.body;
      body.insertParagraph(text, Word.InsertLocation.end);
      await context.sync();
    });
  } catch (error) {
    console.log("Error: " + error);
  }
}

export async function getDocumentText(): Promise<string> {
  // Get the whole document text.
  try {
    return await Word.run(async (context) => {
      let body = context.document.body;
      context.load(body, "text");
      await context.sync();
      return body.text;
    });
  } catch (error) {
    console.log("Error: " + error);
    return "";
  }
}
